export default __webpack_public_path__ + "b72116edf82dca074b8d74bc68f59c82.svg";